import {
    ACTION_DELETE_DELETE_SUBCATEGORIES,
    ACTION_POST_CREATE_SUBCATEGORIES,
    ACTION_DELETE_DELETE_CATEGORIES,
    ACTION_PUT_UPDATE_SUBCATEGORIES,
    ACTION_GET_CATEGORIES_BENEFITS,
    ACTION_POST_CREATE_CATEGORIES,
    ACTION_PUT_UPDATE_CATEGORIES,
    ACTION_GET_SUBCATEGORIES,
    ACTION_GET_CATEGORY_TYPE,
    ACTION_GET_CATEGORIES_ID,
    SET_CATEGORIES_BENEFITS,
    ACTION_GET_CATEGORIES,
    SET_CATEGORIES_ID,
    SET_CATEGORY_TYPE,
    SET_SUBCATEGORIES,
    ACTION_GET_MODE,
    SET_CATEGORIES,
    SET_MODO,

} from "@/views/categories_board/store/types/types.js";

import config from "@/views/categories_board/config/category_board_api.js";
import PathUri from '@/utils/path_uri';
import axios from '@/plugins/http/axios.js';
import Swal from 'sweetalert2';
import  EventBus  from '@/utils/event_bus.js'; 
import i18n from '@/plugins/i18n';

const _pathUri = new PathUri(config.port, config.context);

const actions = {

    [ACTION_GET_CATEGORIES_BENEFITS]: async ({ state, commit }, idModo) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
    
                axios({
                    method: 'get',
                    url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/beneficios/modo/`+idModo,
                    headers: {
                        'idEmpresa': sessionStorage.getItem("idEmpresa"),
                        'idUsuario': sessionStorage.getItem("idUsuario")
                    }
                })
                .then(resp => {
                    
                    if (resp.data && Array.isArray(resp.data.payload)) {
                        const categoriesBenefits = resp.data.payload.map((e, i) => ({
                            ...e,
                            activeDialogClient: false,
                            index: i
                        }));
                        
                        commit(SET_CATEGORIES_BENEFITS, categoriesBenefits);
                        resolve(resp.data);
                    } else {
                        console.error(i18n.t('label.actionRejectError'), resp);
                        reject(i18n.t('label.actionRejectError'));
                    }
                })
                .catch(err => {
                    console.error(i18n.t('label.actionErrorRequest'), err);
                    reject(err);
                })
                .finally(() => {
                    state.loading = false;
                });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_GET_MODE]: async ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
    
                axios({
                    method: 'get',
                    url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/modos/`,
                    headers: {
                        'idEmpresa': sessionStorage.getItem("idEmpresa"),
                        'idUsuario': sessionStorage.getItem("idUsuario")
                    }
                })
                .then(resp => {
                    
                    if (resp.data && Array.isArray(resp.data.payload)) {
                        const modos = resp.data.payload.map((e, i) => ({
                            ...e,
                            activeDialogClient: false,
                            index: i
                        }));
                        
                        commit(SET_MODO, modos);
                        resolve(resp.data);
                    } else {
                        console.error(i18n.t('label.actionRejectError'), resp);
                        reject(i18n.t('label.actionRejectError'));
                    }
                })
                .catch(err => {
                    console.error(i18n.t('label.actionErrorRequest'), err);
                    reject(err);
                })
                .finally(() => {
                    state.loading = false;
                });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_GET_CATEGORIES]: async ({ state, commit }, idModo) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
    
                axios({
                    method: 'get',
                    url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/categoria/modo/${idModo}`,
                    headers: {
                        'idEmpresa': sessionStorage.getItem("idEmpresa"),
                        'idUsuario': sessionStorage.getItem("idUsuario")
                    }
                })
                .then(resp => {
                    if (resp.data.payload && Array.isArray(resp.data.payload)) {
                        const categories = resp.data.payload.map((e, i) => ({
                            ...e,
                            activeDialogClient: false,
                            index: i
                        }));
                        commit(SET_CATEGORIES, categories);
                        resolve(resp.data.payload);
                    } else {
                        console.error(i18n.t('label.actionRejectError'), resp);
                        reject(i18n.t('label.actionRejectError'));
                    }
                })
                .catch(err => {
                    console.error(i18n.t('label.actionErrorRequest'), err);
                    reject(err);
                })
                .finally(() => {
                    state.loading = false;
                });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_GET_CATEGORIES_ID]: async ({ state, commit }, idcategory) => {
        
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
    
                axios({
                    method: 'get',
                    url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/categoria/consult/${idcategory}`,
                    headers: {
                        'idEmpresa': sessionStorage.getItem("idEmpresa"),
                        'idUsuario': sessionStorage.getItem("idUsuario")
                    }
                })
                .then(resp => {
                    if (resp.data.payload) {
                        const category = resp.data.payload
                        
                        commit(SET_CATEGORIES_ID, category);
                        resolve(resp.data.payload);
                    } else {
                        console.error(i18n.t('label.actionRejectError'), resp);
                        reject(i18n.t('label.actionRejectError'));
                    }
                })
                .catch(err => {
                    console.error(i18n.t('label.actionErrorRequest'), err);
                    reject(err);
                })
                .finally(() => {
                    state.loading = false;
                });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_GET_CATEGORY_TYPE]: async ({ state, commit }, idModo) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
    
                axios({
                    method: 'get',
                    url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/tcategorias/modo/${idModo}`,
                    headers: {
                        'idEmpresa': sessionStorage.getItem("idEmpresa"),
                        'idUsuario': sessionStorage.getItem("idUsuario")
                    }
                })
                .then(resp => {
                    if (resp.data && Array.isArray(resp.data.payload)) {
                        const typesCategories = resp.data.payload.map((e, i) => ({
                            ...e,
                            activeDialogClient: false,
                            index: i
                        }));
                        commit(SET_CATEGORY_TYPE, typesCategories);
                        resolve(resp.data.payload);
                    } else {
                        console.error(i18n.t('label.actionRejectError'), resp);
                        reject(i18n.t('label.actionRejectError'));
                    }
                })
                .catch(err => {
                    console.error(i18n.t('label.actionErrorRequest'), err);
                    reject(err);
                })
                .finally(() => {
                    state.loading = false;
                });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },
    
    [ACTION_GET_SUBCATEGORIES]: ({ state, commit }, idCategoria) => {
        return new Promise((resolve, reject) => {
            try {
                commit(SET_SUBCATEGORIES, []);
                state.loading = true;
    
                axios({
                    method: 'get',
                    url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/tproductos/categoria/${idCategoria}?_=${Date.now()}`,
                    headers: {
                        'idEmpresa': sessionStorage.getItem("idEmpresa"),
                        'idUsuario': sessionStorage.getItem("idUsuario")
                    }
                })
                .then(resp => {

                    if (resp.data.payload) {
                        const subcategories = resp.data.payload.tipoProductos.map((e, i) => ({
                            ...e,
                            nombreCategoria: resp.data.payload.nombreCategoria,
                            activeDialogClient: false,
                            index: i
                        }));
                        commit(SET_SUBCATEGORIES, subcategories);
                        resolve(resp.data.payload);
                    } else {
                        console.error(i18n.t('label.actionRejectError'), resp);
                        reject(i18n.t('label.actionRejectError'));
                    }
                })
                .catch(error => {
                    console.error(i18n.t('label.actionErrorRequest'), error);
                    reject(error);
                })
                .finally(() => {
                    state.loading = false;
                });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_POST_CREATE_CATEGORIES]: ({ state }, category) => {
        return new Promise((resolve, reject) => {
            state.loading = true;
    
            axios({
                method: 'post',
                url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/categoria/create/`,
                data: {
                    nombre: category.nombre,
                    descripcion: category.descripcion,
                    idModo: category.idModo,
                    responsable: category.responsable,
                    correo: category.correo,
                    telefono: category.telefono,
                    idCategoriaBeneficio: category.idCategoriaBeneficio,
                    idTipoCategoriaComercial: category.idTipoCategoriaComercial,
                    idImagenCategoria: category.idImagenCategoria
                },
                headers: {
                    'Content-Type': 'application/json',
                    'idEmpresa': sessionStorage.getItem("idEmpresa"),
                    'idUsuario': sessionStorage.getItem("idUsuario")
                }
            })
            .then(resp => {
                if (resp.data.payload) {
                    Swal.fire({
                        position: 'top-end',
                        icon: 'success',
                        title: i18n.t('board.actionPostCreateCategories.success'),
                        showConfirmButton: false,
                        timer: 2500
                    });
                    resolve(resp.data);
                } else {
                    console.error(i18n.t('label.actionRejectError'), resp);
                    reject(i18n.t('label.actionRejectError'));
                }
            })
            .finally(() => {
                state.loading = false;
            });
        });
    },
    
    [ACTION_PUT_UPDATE_CATEGORIES]: ({ state }, category) => {
        return new Promise((resolve, reject) => {
            state.loading = true;
    
            axios({
                method: 'put',
                url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/categoria/update/`,
                data: {
                    idCategoriaComercial: category.idCategoriaComercial,
                    nombre: category.nombre,
                    descripcion: category.descripcion,
                    idModo: category.idModo,
                    responsable: category.responsable,
                    correo: category.correo,
                    telefono: category.telefono,
                    idCategoriaBeneficio: category.idCategoriaBeneficio,
                    idTipoCategoriaComercial: category.idTipoCategoriaComercial,
                    idImagenCategoria: category.idImagenCategoria
                },
                headers: {
                    'Content-Type': 'application/json',
                    'idEmpresa': sessionStorage.getItem("idEmpresa"),
                    'idUsuario': sessionStorage.getItem("idUsuario")
                }
            })
            .then(resp => {
                if (resp.data.payload) {
                    Swal.fire({
                        position: 'top-end',
                        icon: 'success',
                        title: i18n.t('board.actionPutUpdateCategories.success'),
                        showConfirmButton: false,
                        timer: 2500
                    });
                    EventBus.$emit('reload-update-categories-sub');
                    resolve(resp.data.payload);
                } else {
                    console.error(i18n.t('label.actionRejectError'), resp);
                    reject(i18n.t('label.actionRejectError'));
                }
            })
            .finally(() => {
                state.loading = false;
            });
        });
    },
    
    [ACTION_DELETE_DELETE_CATEGORIES]: async ({ state }, idCategory) => {
        try {
            const resp = await new Promise((resolve, reject) => {
                state.loading = true;
                axios({
                    method: 'delete',
                    url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/categoria/delete/${idCategory}`,
                    headers: {
                        'idEmpresa': sessionStorage.getItem("idEmpresa"),
                        'idUsuario': sessionStorage.getItem("idUsuario")
                    }
                })
                .then(resp => {
                    if (resp && resp.status === 200) {
                        EventBus.$emit('reload-delete');

                        Swal.fire({
                            position: 'top-end',
                            icon: 'success',
                            title: i18n.t('board.actionDeleteBoard.success'),
                            showConfirmButton: false,
                            timer: 2500
                        });

                        resolve(resp);
                    } else {
                        reject(i18n.t('label.actionRejectError'));
                    }
                })
                .catch(err => {
                    reject(err);
                });
            });
    
            return resp;
        } catch (err) {
            return Promise.reject(err);
        }
    },    

    [ACTION_POST_CREATE_SUBCATEGORIES]: ({ state }, payload) => {
        return new Promise((resolve, reject) => {
            state.loading = true;
    
            axios({
                method: 'post',
                url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/tproductos/create/`,
                data: {
                    nombre: payload.nombre,
                    descripcion: payload.descripcion,
                    categoriaComercial: payload.idCategoriaComercial,
                    modo: payload.modo
                },
                headers: {
                    'Content-Type': 'application/json',
                    'idEmpresa': sessionStorage.getItem("idEmpresa"),
                    'idUsuario': sessionStorage.getItem("idUsuario")
                }
            })
            .then(response => {
                
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: i18n.t('board.actionPostCreateSubCategories.success'),
                    showConfirmButton: false,
                    timer: 2500
                });
                EventBus.$emit('reload-create-submarketplace');
                resolve(response.data);

            })
            .catch(error => {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            })
            .finally(() => {
                state.loading = false;
            });
        });
    },
    
    [ACTION_PUT_UPDATE_SUBCATEGORIES]: ({ state }, payload) => {
        return new Promise((resolve, reject) => {
            state.loading = true;
    
            axios({
                method: 'put',
                url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/tproductos/update/`,
                data: {
                    nombre: payload.nombre,
                    descripcion: payload.descripcion,
                    categoriaComercial: payload.categoriaComercial,
                    modo: payload.modo,
                    idTipoProducto: payload.idTipoProducto
                },
                headers: {
                    'Content-Type': 'application/json',
                    'idEmpresa': sessionStorage.getItem("idEmpresa"),
                    'idUsuario': sessionStorage.getItem("idUsuario")
                }
            })
            .then(resp => {
                if (resp.data) {
                    Swal.fire({
                        position: 'top-end',
                        icon: 'success',
                        title: i18n.t('board.actionPutUpdateSubCategories.success'),
                        showConfirmButton: false,
                        timer: 2500
                    });
                    resolve(resp.data);
                } else {
                    console.error(i18n.t('label.actionRejectError'), resp);
                    reject(i18n.t('label.actionRejectError'));
                }
            })
            .finally(() => {
                state.loading = false;
            });
        });
    },    
    
    [ACTION_DELETE_DELETE_SUBCATEGORIES]: async ({ state }, idSubCategory) => {    
        try {
            const resp = await new Promise((resolve, reject) => {
                state.loading = true;
                axios({
                    method: 'delete',
                    url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/tproductos/delete/${idSubCategory}`,
                    headers: {
                        'idEmpresa': sessionStorage.getItem("idEmpresa"),
                        'idUsuario': sessionStorage.getItem("idUsuario")
                    }
                })
                .then(resp => {
                    
                    EventBus.$emit('reload-delete-sub');

                    Swal.fire({
                        position: 'top-end',
                        icon: 'success',
                        title: i18n.t('board.actionDeleteSubCategories.success'),
                        showConfirmButton: false,
                        timer: 2500
                    });
                    
                    resolve(resp);
            
                })
                .catch(err => {
                    reject(err);
                });
            });
    
            return resp;
        } catch (err) {
            return Promise.reject(err);
        }
    },
    
}

export default actions;